import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IOverviewColumn, OrderDirection } from './overview-column';

@Component({
    selector: 'app-overview-sorting',
    templateUrl: './overview-sorting.component.html',
    styleUrls: ['./overview-sorting.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class OverviewSortingComponent {
    @Input() public columns: IOverviewColumn[] = [];
    @Output() public sort = new EventEmitter<IOverviewColumn>();

    public OrderDirection = OrderDirection;

    public onSort(column: IOverviewColumn) {
        const clonedColumn = Object.assign({}, column);

        this.columns.forEach((col) => (col.orderDirection = null));
        const currentColumn = this.columns.find((col) => col.name === clonedColumn.name);

        switch (clonedColumn.orderDirection) {
            case OrderDirection.asc:
                currentColumn.orderDirection = OrderDirection.desc;
                break;
            case OrderDirection.desc:
                currentColumn.orderDirection = OrderDirection.asc;
                break;
            default:
                currentColumn.orderDirection = OrderDirection.asc;
                break;
        }

        this.sort.emit(currentColumn);
    }
}
